export default __webpack_public_path__ + "static/media/imagePickAndPackContentTwo.b8a30326.png";